<template>
  <td v-if="renderCell" :class="className" class='text-center' @click="cellclick">
    <input ref="cellinput" class='k-checkbox' type='checkbox' :disabled="!isEditable" :checked="localValue" @change="change" @blur="blur" />
  </td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'

export default {
  name: 'checkbox-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  mounted () {
    this.localValue = this.value
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
    }
  },
  watch: {
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    value: function () {
      return !!getNestedValue(this.field, this.dataItem)
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return `${this.extraparams.title}: ${value ? i18n.t('app.yes') : i18n.t('app.no')}`
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    change (value) {
      var dataItem, field
      if (typeof value === 'object' &&
        Object.hasOwnProperty.call(value, 'dataItem') &&
        Object.hasOwnProperty.call(value, 'field') &&
        Object.hasOwnProperty.call(value, 'value')) {
        ({ dataItem, field, value } = value)
      } else {
        dataItem = this.dataItem
        field = this.field
      }
      this.$emit('change', { dataItem, field, value })
    },
    blur (e) {
      // this.$emit('blur', e)
    },
    cellclick (e) {
      this.$emit('cellclick', { dataItem: this.dataItem, field: this.field, event: e })
    },
    getNestedValue: getNestedValue
  }
}
</script>
